module.exports = __webpack_public_path__ + "assets/media/chat.ba93b57a.svg";